import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import contactWayPageStore from '@src/pages/main/components/contactWayPage/store';
import cx from 'classnames';
import toWebpImage from '@src/utils/to-webp-image';

// import AgeAppropriateTips from '@src/components/age-appropriate-tips';

const styles = require('./index.less');

const contactWayPage = ({ store }) => {
  store.use();

  return (
    <div className={cx(styles.root, store.isActive && styles.rootAvtive)}>
      <div className={styles.title} style={{ backgroundImage: `url(${toWebpImage(require('./images/' + store.mainStore.Lang() + '/title.png'))})` }} />
      <div className={styles.content}>
        <div
          onClick={() => {
            store.gotoCustomer(store.mainStore.Lang());
          }}
          className={styles.customerService}
          style={{ backgroundImage: `url(${toWebpImage(require('./images/' + store.mainStore.Lang() + '/customerService.png'))})` }}
        />
        <div
          className={styles.email}
          onClick={() => {
            store.copyEmail();
          }}
          style={{ backgroundImage: `url(${toWebpImage(require('./images/' + store.mainStore.Lang() + '/email.png'))})` }}
        />
        <div className={styles.mtBox}>
          <div className={styles.mtTitle} style={{ backgroundImage: `url(${toWebpImage(require('./images/' + store.mainStore.Lang() + '/mtTitle.png'))})` }} />
          <div className={styles.usBox}>
            {store.itemList.map((item, key) => {
              return (
                <div
                  className={styles.listItem}
                  key={key}
                  onClick={() => {
                    store.onRedirectLink(item.link);
                    item.onClick();
                  }}
                >
                  <img src={item.img} alt={''} />
                </div>
              );
            })}
          </div>
          <div className={styles.bottomLine} />
        </div>
      </div>
    </div>
  );
};

export default wrapStore(contactWayPage, contactWayPageStore);
